// extracted by mini-css-extract-plugin
export default {"StickyBlock":"bfg_a big_bj"};